import { XCircle, WarningCircle } from "@phosphor-icons/react";
import { amazonUrl } from "@/lib/links";

// Deals-style ASIN status: ASIN (green = verified, orange = unverified),
// NOT ON AMAZON (gray), NO ASIN (red). Tiny dot in front = price source
// (green live / yellow partial / gray demo prices).
export default function AsinStatusPill({ row, testId }) {
  const src = row.data_source;
  const dot = src === "live"
    ? { cls: "bg-[#00A850]", title: "Prices: LIVE (Amazon + BrickLink)" }
    : src === "partial"
      ? { cls: "bg-[#E3000B]", title: "Prices: PARTIAL (one side live)" }
      : { cls: "bg-zinc-700", title: "Prices: DEMO — run a scan to fetch real prices" };
  const stop = (e) => e.stopPropagation();

  let pill;
  if (row.asin) {
    pill = (
      <a href={amazonUrl(row.asin, row.set_number, !!row.asin_verified)} target="_blank" rel="noopener noreferrer" onClick={stop}
         title={row.asin_verified ? "Verified ASIN — open on Amazon" : "ASIN not yet verified — click to check on Amazon"}
         data-testid={`asin-link-${row.set_number}`}
         className={`inline-flex items-center px-1.5 h-5 border rounded-sm font-mono text-[10px] font-bold hover:underline ${
           row.asin_verified
             ? "border-[#00A850]/40 bg-[#00A850]/[0.08] text-[#00A850]"
             : "border-[#D97706]/40 bg-[#D97706]/[0.08] text-[#D97706]"
         }`}>{row.asin}</a>
    );
  } else if (row.amazon_listed === false) {
    pill = (
      <span title="Confirmed not on Amazon" data-testid={`asin-not-on-amazon-${row.set_number}`}
            className="inline-flex items-center gap-1 px-1.5 h-5 border border-[#71717A]/40 bg-[#71717A]/[0.10] text-gray-600 rounded-sm font-mono text-[10px] whitespace-nowrap">
        <XCircle size={10} weight="fill" /> NOT ON AMAZON
      </span>
    );
  } else {
    pill = (
      <span title="No ASIN saved — run ASIN ONLY / Scan Amazon to find one" data-testid={`asin-missing-${row.set_number}`}
            className="inline-flex items-center gap-1 px-1.5 h-5 border border-[#FF3333]/40 bg-[#FF3333]/[0.06] text-[#FF3333] rounded-sm font-mono text-[10px] whitespace-nowrap">
        <WarningCircle size={10} weight="fill" /> NO ASIN
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1.5" data-testid={testId}>
      <span className={`inline-block w-1.5 h-1.5 rounded-full shrink-0 ${dot.cls}`} title={dot.title} data-testid={`source-dot-${row.set_number}`} />
      {pill}
    </span>
  );
}
